import * as angular from 'angular';
import * as _ from 'lodash';
import * as Actions from './tasks.actions';

import { ITaskService } from '../../services/';
import { Dispatcher, GetStore } from '../Store';
import { ITask } from '../../models/';

export interface ITaskActionsService {
    //getAll(): Dispatcher<ITask[]>;
    //getAll(force: boolean): Dispatcher<ITask[]>;
    //getOne(guid: string): Dispatcher<ITask>;
    deleteAllCompleted(): Dispatcher<ITask[]>;
    //addOne(element: ITaskConfiguration, type: OfflineTaskType, force?: boolean): Dispatcher<ITask[]>;
}

export class TaskActionsService implements ITaskActionsService {
    static serviceId = 'taskActionsService';
    static $inject = ['$q', 'taskService'];

    constructor(private _$q: angular.IQService,
        private _taskService: ITaskService) {
    }

    // TODO all typings should redone and rechecked as they looks wrong
    /*
    getAll();
    getAll(force: boolean);
    getAll(force?: boolean): Dispatcher<ITask[]> {
        return (dispatch: Function, getState: GetStore) => {
            const { tasks } = getState();
            if (force || !tasks.isLoading && !tasks.isLoaded) {
                dispatch(Actions.loadTasks());
                return this._taskService
                    .getAll(force)
                    .then(data => {
                        const results = data;
                        dispatch(Actions.loadTasksSuccess(results));
                        return results;
                    })
                    .catch((reason) => {
                        dispatch(Actions.loadTasksError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<ITask>(tasks.dictionary));
            }
        };
    }
    */

    /* This is wrong, not getOne nor getAll return ITask
    getOne(guid: string): Dispatcher<ITask> {
        return (dispatch: Function, getState: GetStore) => {
            const { tasks } = getState();
            if (!tasks.isLoading && !tasks.isLoaded) {
                dispatch(Actions.loadTasks());
                return this._taskService
                    .get(guid)
                    //.getAll(true)
                    .then(result => {
                        //const result = data.map(d => d.taskGuid === guid);
                        dispatch(Actions.loadTaskSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch(Actions.loadTaskError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<ITask>(tasks.dictionary), c => c.guid === guid));
            }
        };
    }
    */

    deleteAllCompleted(): Dispatcher<ITask[]> {
        return (dispatch: Function, getState: GetStore) => {
            dispatch(Actions.deleteTasksCompleted());
            return this._taskService
                .deleteCompletedtasks()
                .then(data => {
                    const results = data;
                    dispatch(Actions.deleteTasksCompletedSuccess(results));
                    return results;
                })
                .catch((reason) => {
                    dispatch(Actions.deleteTasksCompletedError(reason));
                    return reason;
                });
        };
    }

    //TODO is this used somewhere? The expected result type does not match the actual one....
    /*addOne(element: ITaskConfiguration, type: OfflineTaskType, force?: boolean): Dispatcher<ITask[]> {
        return (dispatch: Function, getState: GetStore) => {
            dispatch(Actions.addTask());
            switch (type) {
                case OfflineTaskType.Acquisition:
                    const acquisitionTaskConfiguration = element as AcquistionTaskConfiguration;
                    const doForce = force ? true : false;
                    return this._taskService
                        .createAcquisitionTask(acquisitionTaskConfiguration, doForce)
                        .then(data => {
                            const results = data;
                            dispatch(Actions.addTaskSuccess(results));
                            return data;
                        })
                        .catch(reason => {
                            dispatch(Actions.addTaskError(reason));
                            return reason;
                        });
                case OfflineTaskType.Reprocessing:
                    const workflowTaskConfiguration = element as WorkflowTaskConfiguration;
                    return this._taskService
                        .createWorkflowTask(workflowTaskConfiguration)
                        .then(data => {
                            const results = data;
                            dispatch(Actions.addTaskSuccess({} as any));
                            return data;
                        })
                        .catch(reason => {
                            dispatch(Actions.addTaskError(reason));
                            return reason;
                        });
                case OfflineTaskType.Cleaning:
                    const cleaningTaskConfiguration = element as CleaningTaskConfiguration;
                    return this._taskService
                        .createCleaningTask(cleaningTaskConfiguration)
                        .then(data => {
                            const results = data;
                            dispatch(Actions.addTaskSuccess(results));
                            return data;
                        })
                        .catch(reason => {
                            dispatch(Actions.addTaskError(reason));
                            return reason;
                        });
                    break;
            }
        };*/
}